export const Calculations = {
  calculateTotalPayable(amount: number, tenure: number, interestRate: number): number {
    if (interestRate === 0) {
      return amount;
    }
    const i = ((interestRate / 100) / 12);
    const i_to_m = (i + 1) ** tenure;
    const p = amount * ((i * i_to_m) / (i_to_m - 1));
    return Math.round(p * tenure * 100) / 100;
  },

  totalPayable(
    amountBorrowed: number, tenure: number, fee_rate: string, nominal_annual_interest_rate: string
  ): number {
    const fees = amountBorrowed * (parseFloat(fee_rate) / 100);
    return this.calculateTotalPayable(
      amountBorrowed + fees, tenure, parseFloat(nominal_annual_interest_rate)
    );
  },
};
